import Spin from '@/components/common/spin';
import {auth} from '@/config/firebase';
import {type AppRouteObject} from '@/router/interface';
import routes from '@/router/routes';
import {useAuthState} from 'react-firebase-hooks/auth';
import {
  Navigate,
  Outlet,
  type RouteObject,
  createBrowserRouter
} from 'react-router-dom';

const RequireAuth = ({children}: any) => {
  const [user, loading] = useAuthState(auth);
  if (!user && !loading) {
    return <Navigate to="/login" replace />;
  }
  if (user && !loading) {
    return children;
  }

  return <Spin />;
};

const wrappedRouter = (routes: AppRouteObject[]): RouteObject[] => {
  return routes.map((route) => {
    const {element, children, isProtected, ...rest} = route;
    let finalElement = element ?? <Outlet />;
    if (isProtected) {
      finalElement = <RequireAuth>{element ?? <Outlet />}</RequireAuth>;
    }
    const newRoute: RouteObject = {...rest, element: finalElement};
    if (Array.isArray(children) && children.length) {
      newRoute.children = wrappedRouter(children);
    }

    return newRoute;
  });
};

const router = createBrowserRouter(wrappedRouter(routes));
export default router;
